export default __webpack_public_path__ + "static/media/arrow-left.fc29ec73.svg";